import hateoas from 'viralstyle-ui/src/hateoas';

export const contact = async ({ state, dispatch, commit }) => {
  let response = await dispatch('post', { apiUrl: hateoas.url('contact_us'), payload: state.info.payload });

  commit('clearContactForm');

  return response;
};